export const modalDarkBlueColors = {
  background: '#16191F',
  modalCard: 'rgb(38 44 54 / 60%)',
  stroke: 'rgba(255,255,255,0.06)',
  titleText: '#fff',
  textSecondary: 'rgba(255,255,255,0.72)',
}
